export default __webpack_public_path__ + "static/media/Badge_silver.a2bfc251.svg";